import ConfirmDeleteModal from 'src/common/components/ConfirmDeleteModal';

type Props = {
  fileNames: string[] | null;
  entityName: 'file' | 'document';
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
};

export default function BulkDeleteConfirmModal({
  fileNames,
  entityName,
  onClose,
  onConfirm,
  isLoading,
}: Props) {
  const count = fileNames?.length ?? 0;

  return (
    <ConfirmDeleteModal
      opened={fileNames !== null}
      onClose={onClose}
      onConfirm={onConfirm}
      title={count === 1 ? `Delete ${entityName}` : `Delete ${count} ${entityName}s`}
      message={
        count === 1
          ? `Are you sure you want to delete "${fileNames?.[0]}"? This action cannot be undone.`
          : `Are you sure you want to delete these ${count} ${entityName}s? This action cannot be undone.`
      }
      isLoading={isLoading}
    />
  );
}
